import { Outlet } from 'react-router-v7';

// These CSS files are required for Pantry components to render correctly.
// consumer-tokens.css defines --pantry-* CSS custom properties.
// index.css defines component styles that reference those tokens.
// Both use Pantry-prefixed selectors and do not conflict with existing MUI styles.
import './PantryLayout.css';
import '@tocktix/pantry/consumer-tokens.css';
import '@tocktix/pantry/index.css';

export default function PantryLayout() {
  return (
    <div className="PantryScope">
      <Outlet />
    </div>
  );
}
